import { BaseUrl } from './AuthApi';
import { axiosClient } from './AxiosClient';
export const apiInstance = axiosClient(BaseUrl);
